function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#BEFFFC",
  d: "M99.789 80.175h12.044V68.13H99.789zm0 21.557h12.044V89.687H99.789zM24.338 68.664a9.604 9.604 0 1 0 19.209 0 9.604 9.604 0 0 0-19.209 0"
}), React.createElement("path", {
  d: "M31.305 68.36a8.773 8.773 0 0 0 8.773 8.772 8.772 8.772 0 0 0 8.773-8.773 8.773 8.773 0 0 0-17.546 0zM12.66 81.96v13.525h13.526m-.001-54.101H12.66v13.525m54.102 0V41.384H53.237m-.001 54.101h13.525V81.96m35.278-23.343h12.044V46.572h-12.044zm0 21.558h12.044V68.13h-12.044zm0 21.557h12.044V89.687h-12.044zm22.119-54.502h39.2m-39.2 10.511h29.674m-29.674 10.512h39.2m-39.2 10.511h29.674m-29.674 10.512h39.2m-39.2 10.512h29.674",
  stroke: "#2B3787",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M57.278 121.247c0 8.017 6.498 14.514 14.514 14.514 8.015 0 14.513-6.497 14.513-14.514 0-8.016-6.498-14.514-14.513-14.514-8.016 0-14.514 6.498-14.514 14.514",
  fill: "#BEFFFC"
}), React.createElement("path", {
  stroke: "#2B3787",
  strokeWidth: 0.4,
  d: "M59.364 123.891H1.2v-95.69h74.799v78.811"
}), React.createElement("path", {
  d: "M59.14 121.57c0 8.12 6.582 14.7 14.7 14.7 8.118 0 14.7-6.58 14.7-14.7 0-8.118-6.582-14.699-14.7-14.699-8.118 0-14.7 6.581-14.7 14.7zm21.549-7.616L66.553 128.09m14.136 0l-14.136-14.136m44.707-21.518l-6.067 6.067m6.067.001l-6.067-6.067m6.067-21.421l-6.067 6.067m6.067.001l-6.067-6.067m-.419-18.962l2.615 2.615 4.394-4.394",
  stroke: "#2B3787",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 165 165",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/flow/reason.svg